import type { OverviewResponse } from "contracts/api/dashboard/responses";
import { For } from "solid-js";
import { pageDisplayLabel } from "../pages/boundaries/page-label.parser";
import { isStrategicPage } from "./scanExperienceModel";
import { estateClusters, pageContentFitnessScore } from "./scanModel";

export function SummaryStructureMobileList(props: {
  data: OverviewResponse;
  href: (pageId: string) => string;
}) {
  const clusters = () =>
    [...estateClusters(props.data)].sort(
      (left, right) =>
        right.weakPages - left.weakPages ||
        right.importantPages - left.importantPages ||
        right.pages.length - left.pages.length ||
        left.label.localeCompare(right.label),
    );
  const focusPage = (cluster: ReturnType<typeof estateClusters>[number]) => {
    const priority = cluster.pages.find((page) =>
      isStrategicPage(props.data, page),
    );
    if (priority) return priority;
    return (
      [...cluster.pages]
        .filter((page) => pageContentFitnessScore(page) !== null)
        .sort(
          (left, right) =>
            (pageContentFitnessScore(left) ?? 101) -
            (pageContentFitnessScore(right) ?? 101),
        )[0] ?? cluster.pages[0]
    );
  };
  return (
    <div class="signal-summary-structure-mobile">
      <p class="signal-muted">
        Cluster overview from the current scan. Open Flows for the full
        interactive structure.
      </p>
      <div class="signal-summary-cluster-list">
        <For each={clusters()}>
          {(cluster, index) => {
            const page = focusPage(cluster);
            return (
              <article class="signal-summary-cluster-card">
                <div>
                  <span class="signal-summary-cluster-rank">{index() + 1}</span>
                  <strong>{cluster.label}</strong>
                  <span>
                    {cluster.pages.length} page
                    {cluster.pages.length === 1 ? "" : "s"}
                  </span>
                </div>
                <p>{pageDisplayLabel(page, props.data.site)}</p>
                <small>
                  {pageContentFitnessScore(page) === null
                    ? "No scored data"
                    : `Content Fitness ${pageContentFitnessScore(page)}`}
                  {cluster.weakPages > 0
                    ? ` / ${cluster.weakPages} needing attention`
                    : ""}
                  {cluster.importantPages > 0
                    ? ` / ${cluster.importantPages} linked to priority issues`
                    : ""}
                </small>
                <a class="signal-text-action" href={props.href(page.id)}>
                  Inspect cluster in Flows
                </a>
              </article>
            );
          }}
        </For>
      </div>
    </div>
  );
}
